import { ChangeDetectionStrategy, Component, Input,Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from 'src/modules/base/services/util.service';
import _moment from 'proxies/dayjs';
const moment = _moment
@Component({
    selector: 'app-kx-ai-patient-summary',
    templateUrl: './kx-ai-patient-summary.html',
    styleUrls: ['./kx-ai-patient-summary.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PatientSummaryComponent {
  @Input() data: any = null;
  @Input() selectedDatas:any=[]
  // Independent toggle states for the top cards
  isDiagnosisExpanded = false;
  isCriticalExpanded = false;
  curData: { patient_age?: string } | null = null;
  patientAgeDisplay: string = '';
  constructor(public utilService: UtilService) {
  }
  ngOnInit() {
    console.log(this.data,"from summary")
    this.curData  = JSON.parse(sessionStorage.getItem("currentData") || "null");
    this.patientAgeDisplay = this.formatPatientAge();
    if(this?.data?.critical_findings?.abnormal_vitals)
    {
      const cleanedVitals = this?.data?.critical_findings.abnormal_vitals?.replace(/Â/g, '');
      this.data.critical_findings.abnormal_vitals=cleanedVitals
    }
  }
  // getEncounterIds() {
  //   let encounterIds = this.selectedDatas.map((ele) => ele.encounter_id);
  //   // return encounterIds.join(', ')
  // }
  formatDate(timestamp: number): string {
    if (!timestamp || isNaN(timestamp)) return '';
    // const date = new Date(timestamp);
    // const day = String(date.getDate()).padStart(2, '0');
    // const month = String(date.getMonth() + 1).padStart(2, '0');
    // const year = String(date.getFullYear()).slice(-2);
    // return `${day}/${month}/${year}`;
    let facilityDate = this.utilService.toTimeZoneDateFormat(timestamp, 'datetime');
    return facilityDate;
  }
  private formatPatientAge(): string {
    const age = this.curData['patient_age']
    if (!age) return '';
    return age.split(',')[0].replace(/\s+/g, '');
  }
  get acuityColorClass(): string {
    const acuity = this.data?.diagnosis_status?.acuity || 'Stable';
    switch (acuity) {
      case 'Critical': return 'status-critical';
      case 'Deteriorating': return 'status-warning';
      case 'Improving': return 'status-success';
      default: return 'status-neutral';
    }
  }

  isValue(val: any): boolean {
    return !!val && val !== 'null' && val !== 'undefined';
  }

  get hasCriticalFindings(): boolean {
    if (!this.data?.critical_findings) return false;
    const f = this.data.critical_findings;
    return !!(this.isValue(f.abnormal_vitals) || (f.critical_labs && f.critical_labs.length > 0) || this.isValue(f.imaging_highlights));
  }

  get hasTreatment(): boolean {
    if (!this.data?.treatment_administered) return false;
    const t = this.data.treatment_administered;
    return !!((t.procedures_performed && t.procedures_performed.length > 0) || 
              (t.acute_medications && t.acute_medications.length > 0) ||
              t.non_pharm_interventions);
  }
}